declare var processEpcPath: string;
declare var searchByBarcodePath: string;
declare var markAsShippedPath: string;

export class ShippingApiService {
    static async fetchAssetByEpc(epc: string): Promise<any> {
        return $.ajax({
            url: processEpcPath,
            method: "GET",
            data: { epc: epc.trim() },
            dataType: "json"
        });
    }

    static async fetchTableData(barcode: string): Promise<any> {
        return $.ajax({
            url: searchByBarcodePath,
            method: "GET",
            data: { so_barcode: barcode.trim() },
            dataType: "json"
        });
    }

    static async markShipped(assetId: string | number): Promise<any> {
        if (!assetId) {
            throw new Error("Asset ID is required");
        }
        
        return $.ajax({
            url: markAsShippedPath,
            method: "POST",
            data: { asset_id: String(assetId) },
            dataType: "json"
        });
    }
}

